// src/themes/index.js
// Registry central de temas.

import vibrante from './vibrante'
import desaturado from './desaturado'
import tactical from './tactical'
import neon from './neon'
import diurno from './diurno'

export const CATALOG = { vibrante, desaturado, tactical, neon, diurno }
export const DEFAULT_THEME = 'vibrante'

export function getEnabledThemes() {
  const envList = import.meta.env.VITE_APP_ENABLED_THEMES
  if (!envList) return Object.values(CATALOG)
  const allowed = envList.split(',').map(s => s.trim()).filter(Boolean)
  return allowed.map(id => CATALOG[id]).filter(Boolean)
}

export function getTheme(id) {
  return CATALOG[id] || CATALOG[DEFAULT_THEME]
}
